import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MapPin, Search, X } from 'lucide-react';

const EASE = [0.22, 1, 0.36, 1];

const SearchSection = ({
  wrapperRef,
  onSubmit,
  query,
  handleSearchChange,
  suggestions,
  loadingSuggestions,
  setShowDropdown,
  resetAll,
  showDropdown,
  onSelectSuggestion,
  searchError
}) => (
  <div className="vlg-search" ref={wrapperRef}>
    <form className="vlg-search__form" onSubmit={onSubmit} role="search">
      <Search className="vlg-search__icon" aria-hidden="true" />
      <input
        type="text"
        className="vlg-search__input"
        placeholder="Search your business name and city…"
        aria-label="Search your business name and city"
        autoComplete="off"
        value={query}
        onChange={(event) => handleSearchChange(event.target.value)}
        onFocus={() => {
          if (query.trim().length >= 2 && (suggestions.length > 0 || loadingSuggestions)) {
            setShowDropdown(true);
          }
        }}
      />
      {query && (
        <button className="vlg-search__clear" type="button" onClick={resetAll} aria-label="Clear search">
          <X size={18} />
        </button>
      )}
      {/* Honeypot - invisible to humans, scraped by naive bots. */}
      <input
        type="text"
        name="website"
        data-honeypot="grader"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        defaultValue=""
        style={{ position: 'absolute', left: '-9999px', width: 0, height: 0, opacity: 0, pointerEvents: 'none' }}
      />
    </form>

    <AnimatePresence>
      {showDropdown && (
        <motion.div
          className="vlg-ac"
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.18, ease: EASE }}
        >
          {loadingSuggestions ? (
            <div className="vlg-ac__loading">
              <span className="vlg-ac__dot" aria-hidden="true" />
              <span>Finding businesses…</span>
            </div>
          ) : suggestions.length > 0 ? (
            <div className="vlg-ac__list" role="listbox" aria-label="Matching businesses">
              {suggestions.map((business) => (
                <button
                  key={business.id || `${business.name}-${business.city}`}
                  className="vlg-ac__item"
                  type="button"
                  role="option"
                  aria-selected="false"
                  onClick={() => onSelectSuggestion(business)}
                >
                  <span className="vlg-ac__copy">
                    <span className="vlg-ac__name">{business.name}</span>
                    <span className="vlg-ac__meta">
                      <span className="vlg-ac__loc">
                        <MapPin size={13} aria-hidden="true" />
                        {business.city || 'Local area'}
                      </span>
                      {business.rating && business.rating !== 'N/A' && (
                        <span className="vlg-ac__rating">★ {business.rating}</span>
                      )}
                    </span>
                  </span>
                  <span className="vlg-ac__arrow" aria-hidden="true">→</span>
                </button>
              ))}
            </div>
          ) : (
            <div className="vlg-ac__empty">
              {searchError || 'No businesses found. Try a broader search.'}
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default SearchSection;
